// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"200":"5fbd852e","292":"5fbd852e","321":"5fbd852e","325":"5fbd852e","638":"5fbd852e","788":"56b66dba","894":"5fbd852e","910":"56b66dba"}[chunkId] + ".chunk.css";
};